import React from "react"
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useNavigate } from 'react-router';
import { Button, Box, Grid, Typography, Paper } from '@mui/material'
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import { selectSettingForTypeKeyName } from "../../../reducers/reference_settings";
import { useSelector } from "react-redux";

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const HomeHealthTools = (props) => {
    const {component} = props
    const HealthToolsFrame = component.HealthTools
    const HealthShelfFrame = component.HealthShelfFrame
    const setting_medikeeper = useSelector(state=>selectSettingForTypeKeyName(state,{SettingTypeKeyName:'MEDIKEEPER ENABLED MENU'}))
    const setting_healthshelf= useSelector(state=>selectSettingForTypeKeyName(state,{SettingTypeKeyName:'SHOW HEALTH SHELF'}))
    const { HealthShelfIcon, HealthShelfLink, HealthShelfText, HealthShelfTitle } = HealthShelfFrame
    const PrintView = false
    const { Image, List, Subtitle, Title, Visible } = HealthToolsFrame
    const { URL, Text } = HealthToolsFrame.Button

    const navigate = useNavigate();

    const healthShelfSize = HealthShelfFrame.Visible !== '1' ? 12 : 4
    const HealthToolSize = HealthToolsFrame.Visible !== '1' ? 12 : 4

    if (setting_healthshelf === '1' || setting_medikeeper === '1') {
        return (

            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3}>
                {
                   setting_healthshelf === '1' && (
                        <Grid item xs={12} md={4}>
                            <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                                <Paper elevation={1} sx={{ padding: '24px', height: '100%' }}>
                                    <div>
                                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                            <Grid item xs={12}>
                                                <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                                                    <MenuBookIcon sx={{ fontSize: 150 }} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                                                    <Typography variant="h5" align="center" dangerouslySetInnerHTML={{ __html: HealthShelfTitle }}></Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }} onClick={() => navigate('/healthshelf')}>
                                                    <Typography variant="body1" align="center" dangerouslySetInnerHTML={{ __html: HealthShelfText }}></Typography>

                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row" }}>
                                                    <Button variant="contained" onClick={() => navigate('/healthshelf')}>{HealthShelfLink}</Button>
                                                </Box>
                                            </Grid>
                                        </Grid >
                                    </div>
                                </Paper>
                            </motion.div>
                        </Grid>
                    )
                }

                {
                   setting_medikeeper === '1' && (
                        <Grid item xs={12} md={4}>
                            <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                                <Paper elevation={1} sx={{ padding: '24px', height: '100%' }}>
                                    <div>
                                        <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3}>
                                            <Grid item xs={12} md={12}>
                                                <Box pb={2}>
                                                    <Typography variant="h5" gutterBottom>{Title}</Typography>
                                                </Box>
                                                <Typography variant="body1">{Subtitle}</Typography>
                                                <Box pl={3}>

                                                    {
                                                        List.split('|').map(x => {
                                                            return (<Typography variant="body1">-{"\t"} {x}</Typography>)
                                                        })
                                                    }
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={12} >

                                                <Button variant="contained" href={"../../../WsWebAppWellsuite/" + URL} fullWidth>{Text}</Button>


                                            </Grid>
                                        </Grid >
                                    </div>
                                </Paper>
                            </motion.div>
                        </Grid>
                    )
                }


            </Grid>
        )
    }
    else {
        return (<Box />)
    }
}

export default HomeHealthTools; 